module.exports = __webpack_public_path__ + "static/media/home-button.65e8ba04.png";